import {hexToRgb, primaryColor} from "assets/jss/material-dashboard-pro-react.jsx";

// Dropzone dos modais de importação: conteúdo centrado e nas cores do tema,
// em vez do bloco alto a preto-e-branco que vem por omissão do material-ui-dropzone
const dropzoneImportacao = {
  dropzoneImportacao: {
    minHeight: "150px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderColor: primaryColor,
    backgroundColor: "rgba(" + hexToRgb(primaryColor) + ", 0.04)",
    transition: "background-color 150ms linear",

    "&:hover": {
      backgroundColor: "rgba(" + hexToRgb(primaryColor) + ", 0.08)"
    },

    "& .MuiDropzoneArea-textContainer": {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      padding: "10px 20px"
    },

    "& .MuiDropzoneArea-text": {
      margin: "0",
      fontSize: "15px",
      color: primaryColor
    },

    "& .MuiDropzoneArea-icon": {
      width: "38px",
      height: "38px",
      marginTop: "12px",
      color: primaryColor
    }
  }
};

export default dropzoneImportacao;
